import { render, staticRenderFns } from "./ServiceFeeRefundDetail.vue?vue&type=template&id=1838ecdc&scoped=true&"
import script from "./ServiceFeeRefundDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeRefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFeeRefundDetail.vue?vue&type=style&index=0&id=1838ecdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838ecdc",
  null
  
)

export default component.exports